import { IBeneficiaryDetails } from '../../../core/modules/admin-modules/beneficiary/models/beneficiary.model';

export class PatchPatientDetails {
  static readonly type = '[Patient] PatchPatientDetails';
  constructor(public payload: IBeneficiaryDetails) { }
}